<template>
  <div class="project-one-get-saved-config-form">
    <div class="text-center">
      <span class="text-md mr-1" qaid="project-one-already-configured-text" v-html="bp('cardAlreadyConfigured')" />

      <trek-button qaid="project-one-enter-build-id-button" text underline @click="isDialogVisible = true">
        <span v-html="bp('cardEnterId')" />
      </trek-button>
    </div>

    <el-dialog
      :visible.sync="isDialogVisible"
      :title="bp('configLoadSaved')"
      :center="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
      :z-index="16000011"
      :close-dialog-tooltip="bp('closeDialogToolTip')"
      qaid="project-one-build-id-dialog-container"
      @close="closeModal"
    >
      <p class="mb-4" qaid="project-one-enter-build-id-dialog-message" v-html="bp('configEnterIdMessage')" />

      <form qaid="project-one-build-id-form" class="mb-2 flex justify-center" @submit.prevent>
        <div class="prepend-form-input relative max-w-xs w-full">
          <span
            v-show="configurationCode.length > 0"
            class="prepend-form-input__text text-gray-50 z-50 text-base absolute left-0 mt-1 ml-2"
            v-html="`P&nbsp;&#8211;&nbsp;`"
          />

          <form-group
            v-model="configurationCode"
            type="text"
            name="configurationCode"
            :maxlength="6"
            :placeholder="bp('configEnterId')"
            class="prepend-form-input__control"
            qaid="project-one-build-id-text-input"
          />
        </div>
      </form>

      <pdl-loading :is-loading="loading">
        <div v-show="Object.keys(data).length > 0 || error" class="flex justify-center">
          <span v-if="error" qaid="project-one-buid-id-error-text" class="text-red" v-html="bp('configError')" />

          <pdl-media-object v-else qaid="project-one-build-id-media-object">
            <div slot="media">
              <img
                qaid="project-one-build-id-media-object-image"
                :src="data.p1ConfigImageUrl"
                width="200px"
                height="200px"
              />
            </div>

            <div slot="content">
              <h4 qaid="project-one-build-id-media-object-content" v-html="data.p1ConfigDescription" />
            </div>
          </pdl-media-object>
        </div>
      </pdl-loading>

      <trek-button
        v-if="Object.keys(data).length > 0 && !error"
        qaid="project-one-build-id-load-button"
        class="mt-4"
        primary
        @click="forwardToSummary"
      >
        <span v-html="bp('configLoad')" />
      </trek-button>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';
import {mapActions} from 'vuex';
import TrekButton from '@/components/TrekButton';
import ElDialog from '@/components/Dialog';
import {PdlLoading} from '@pedal/pdl-loading';
import {PdlMediaObject} from '@pedal/pdl-media-object';
import FormGroup from '@/components/FormGroup';

export default {
  name: 'ProjectOneGetSavedConfigForm',

  components: {TrekButton, ElDialog, PdlLoading, PdlMediaObject, FormGroup},

  data() {
    return {
      isDialogVisible: false,
      configurationCode: '',
      loading: false,
      error: false,
      data: {},
    };
  },

  watch: {
    configurationCode: debounce(function(value) {
      if (value.length === 6) this.fetchBuild();
    }, 200),
  },

  methods: {
    ...mapActions('projectOne', ['fetchBikeConfiguration']),

    async fetchBuild() {
      try {
        this.loading = true;
        this.data = {};
        this.error = false;

        const response = await axios.get(`/project-one/api/configurations/P-${this.configurationCode}/`);

        this.loading = false;

        if (response.status === 200) {
          if (response.data?.data) {
            this.data = response.data.data;
          } else {
            this.data = {};
            this.configurationCode = '';
            this.error = true;
            this.loading = false;
          }
        } else {
          this.data = {};
          this.error = true;
        }
      } catch (error) {
        this.error = true;
        this.loading = false;
        console.log(error);
      }
    },

    forwardToSummary() {
      this.$router.push({
        name: 'summary',
        params: {
          buildId: `P-${this.configurationCode}`,
        },
      });
    },

    closeModal() {
      this.configurationCode = '';
      this.data = {};
      this.isDialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group /deep/ .form-control {
  text-indent: 26px;
}
</style>
